// store
import {
  GET_USERS,
  GET_USERS_LOGIN,
  GET_EXT_USERS,
  CHANGE_USER,
  ADD_USER,
  SET_USERS,
  SET_EXT_USERS,
  DELETE_USER,
  GET_EXT_USERS_RELS,
  SET_EXT_USERS_RELS,
  SET_USERS_LOGIN,
} from "../../store/actions/users";

// api
import {getUsersApi, getExtUsersApi, getRefItemExtUserRelsApi, changeUsersApi, addUsersApi, deleteUsersApi, getLastLoginApi, getLoggedInStatusApi, getLoginsByPeriodApi} from "@/api/users";

const state = {
  users: [],
  extUsers: [],
  usersLogin: []
};

const getters = {
  usersCount: state => state.users.length,
  users: state => state.users.slice().sort((a, b) => Number(a.group) > Number(b.group) ? 1 : -1),
  extUsersCount: state => state.extUsers.length,
  extUsers: state => state.extUsers.slice().sort((a, b) => Number(a.group) > Number(b.group) ? 1 : -1),
  //extUsersCount: state => state.extUsers.length,
  extUsersRels: state => state.extUsersRels,
  usersLogin: state => state.usersLogin
};

const actions = {
  [GET_USERS]: ({commit}) => {
    getUsersApi().then(resp => {
      commit(SET_USERS, resp.data);
    });
  },
  [GET_USERS_LOGIN]: ({commit}) => {
    let arr = []
    getLastLoginApi().then(resp => {
      getLoggedInStatusApi().then(res => {
        resp.data.forEach((item)=> item.status = res.data.find((it)=> it.id == item.id).logged_in)
        arr = resp.data
      });
      getLoginsByPeriodApi('day').then(res => {
        resp.data.forEach((item)=> item.day = res.data.find((it)=> it.id == item.id) ? res.data.find((it)=> it.id == item.id).login_count : 0)
        arr = resp.data
      });
      getLoginsByPeriodApi('week').then(res => {
        resp.data.forEach((item)=> item.week = res.data.find((it)=> it.id == item.id) ? res.data.find((it)=> it.id == item.id).login_count : 0)
        arr = resp.data
      });
      getLoginsByPeriodApi('month').then(res => {
        resp.data.forEach((item)=> item.month = res.data.find((it)=> it.id == item.id) ? res.data.find((it)=> it.id == item.id).login_count : 0)
        arr = resp.data
      });
      arr = resp.data
      console.log("DDDDDDD",  arr)
      setTimeout(()=>commit(SET_USERS_LOGIN, arr), 1000);
    });

  },
  [GET_EXT_USERS]: ({commit}, params) => {
    getExtUsersApi(params).then(resp => {
      commit(SET_EXT_USERS, resp.data.items);
    });
  },
  [GET_EXT_USERS_RELS]: ({commit}, params) => {
    getRefItemExtUserRelsApi(params).then(resp => {
      commit(SET_EXT_USERS_RELS, resp.data);
    });
  },
  [CHANGE_USER]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      changeUsersApi(params)
        .then(resp => {
          commit(CHANGE_USER, {resp: resp.data, email: params.email});
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }),
  [DELETE_USER]: ({ commit }, uid) =>
    new Promise((resolve, reject) => {
      deleteUsersApi({uid})
        .then(() => {
          commit(DELETE_USER, uid);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }),
  [ADD_USER]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      addUsersApi(params)
        .then(resp => {
          commit(ADD_USER, {resp: resp.data, email: params.email});
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    }),
};

const mutations = {
  [DELETE_USER]: (state, uid) => {
    state.users = state.users.filter(item => item.uid !== uid);
  },
  [ADD_USER]: (state, {resp, email}) => {
    state.users.push({...resp, email});
  },
  [CHANGE_USER]: (state, {resp, email}) => {
    state.users = state.users.map(item => {
      if (Number(item.uid) === resp.uid) {
        return {...resp, email}
      }

      return item;
    })
  },
  [SET_USERS]: (state, payload) => {
    state.users = payload;
  },
  [SET_USERS_LOGIN]: (state, payload) => {
    state.usersLogin = payload;
  },
  [SET_EXT_USERS]: (state, payload) => {
    state.extUsers = payload;
  },
  [SET_EXT_USERS_RELS]: (state, payload) => {
    state.extUsersRels = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
